// 中文语言包
export default {
  // App.vue - 导航栏
  nav: {
    home: '首页',
    about: '关于我们',
    case: '项目案例',
    team: '团队介绍',
    culture: '企业文化',
    recruit: '人才招聘',
    contact: '联系我们',
    language: 'English',
  },

  // App.vue - 页脚
  footer: {
    aboutTitle: '关于我们',
    companyProfile: '公司简介',
    projectCase: '项目案例',
    patentCert: '专利证书',
    joinTitle: '加入我们',
    zhilian: '智联招聘',
    boss: 'BOSS直聘',
    contactTitle: '联系我们',
    servicePhone: '服务电话',
    companyAddress: '公司地址',
    businessCooperation: '商务合作',
    qrcode: '扫码关注福卡迪公众号',
    beian1: '鄂公网安备42011302001009号',
    beian2: '鄂ICP备19018302号-1',
  },

  // HomeView.vue - 首页
  home: {
    hero: {
      line1: '打造',
      line2: '一流专业化',
      line3: '汽车技术公司',
    },
    heroDesc: '致力于开发撰写汽车各类技术文档；交通领域工具设备的研发、生产及服务；计算机软件开发及服务',
    // 企业资质卡片
    certTitle1: '企业资质',
    certDesc1: '15年行业沉淀，湖北省官方上榜创新型企业',
    certTitle2: '多项专利',
    certDesc2: '多年的努力和创新，赢得了多项专利和软件著作权',
    certTitle3: 'ISO9001认证',
    certDesc3: '拥有多项行业资质认证，是您放心选择的高新技术企业',
    // 视频展示区
    videoTitle: '视频展示',
    videoDesc: '用产品讲述故事',
    videoItem1Title: '三维CG动画',
    videoItem1Desc: '赢彻科技',
    videoItem2Title: '三维CG动画',
    videoItem2Desc: '极氪001',
    videoItem3Title: '三维CG动画+实拍视频',
    videoItem3Desc: '江铃大道',
    videoItem4Title: '实拍使用视频',
    videoItem4Desc: '江铃大道',
    videoItem5Title: '实拍维修视频',
    videoItem5Desc: '岚图FREE',
    // 三维交互区
    interaction3d: '三维交互',
    interaction3dDesc: '数字控制，实时启动，了解汽车内部结构，掌握细节，让学习更加互动，生动',
    // 相关案例
    caseTitle: '相关案例',
    caseDesc: '用产品讲述故事',
    caseItem1Title: '用户手册',
    caseItem1Desc: '开发了共计86车型的《用户手册》',
    caseItem2Title: '维修手册',
    caseItem2Desc: '开发了共计64车型的《维修手册》',
    caseItem3Title: '拆解书册',
    caseItem3Desc: '开发了共计17车型的《拆解手册》',
    caseItem4Title: '工时手册',
    caseItem4Desc: '开发了共计34车型的《工时手册》',
    caseItem5Title: '专用工具',
    caseItem5Desc: '开发了共计72个车型的专用工具开发',
    caseItem6Title: '培训教材教具',
    caseItem6Desc: '开发了多种车型的培训教材教具',
    // 服务流程
    serviceTitle: '服务流程',
    serviceSubtitle: 'Service Process',
    // 优势
    advantageTitle1: '我们的',
    advantageTitle2: '优势',
    advantageDesc: '秉承"用心服务、确保成果"的经营理念，以专业高效的精神服务客户',
    // 合作伙伴
    partnerTitle: '合作伙伴',
    partnerSubtitle: 'Business Partners',
    // SEO
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // About.vue - 关于我们
  about: {
    title: '公司简介',
    p1: '武汉福卡迪汽车技术有限公司是一家将汽车售后技术文件及培训教材编写、备件目录制作开发、专用工具开发制作、教具制作等一条龙服务的专业化汽车技术公司。',
    p2: '武汉福卡迪汽车技术有限公司成立于2008年1月25日，是一家集汽车售后技术文档、备件目录/EPC开发、专用工具开发制造、培训教材教具展具开发、维修技术信息系统开发和H5系统平台手机APP等服务于一体的专业化汽车技术公司。',
    p3: '福卡迪拥有汽车售后技术理论维修实践经验的精英团队，一直秉承"用心工作、确保成果"的经营理念，以专业高效的精神服务客户。',
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // Case.vue - 项目案例
  case: {
    title: '不可一词无来历 不可一句不讲究',
    desc: '踏踏实实做事，避免"纸上谈兵"。在实践工作中，在"深"字上下功夫，在"实"字上做文章',
    selectCase: '选择案例',
    expand: '展开更多',
    collapse: '收起',
    categories: [
      '用户手册',
      '维修手册',
      '备件目录',
      '电路图',
      '拆解手册',
      '工时手册',
      '专用工具',
      '培训教程教具',
      '视频动画',
      '软件系统',
      '其他',
    ],
    options: [
      '用户手册',
      '维修手册',
      '备件目录',
      '电路图',
      '拆解手册',
      '工时手册',
      '专用工具',
      '培训教程教具',
      '视频动画',
      '软件系统',
      '其它',
    ],
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // Culture.vue - 企业文化
  culture: {
    sloganTitle: '企业口号',
    slogan1: '多想一步、多看一步、多做一步，一次就把事情做成功',
    slogan2: '不可一词无来历，不可一词不讲究',
    philosophyTitle: '经营理念',
    philosophy: '用心工作、确保成果',
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // Team.vue - 团队介绍
  team: {
    roles: [
      {
        title: '汽车技术专家，高级工程师',
        desc: '拥有35 年汽车运用与维修行业经验；陈峰亲自主持和编写过东风汽车公司以及合资和自主品牌汽车的系列使用和维修技术资料，多次法国、西班牙、瑞典的培训和研讨经历。在人民交通出版社和机械工业出版社，出版多本汽车维修书籍，发表多篇汽车维修论文。神龙公司汽车运用专业带头人；武汉市人民政府津贴专家；神龙公司高级工程师专家评委。陈峰曾任全国汽车维修标准化委员会专家委员，全国汽车维修技术信息公开特聘专家，参与国家交通部相关标准的审核修订。',
      },
      {
        title: '汽车维修高级技师',
        desc: '具有多年汽车4S店维修工作经验。实车维修操作，研究切实可行的维修方法。',
      },
      {
        title: '汽车运用工程师',
        desc: '汽车相关专业本科毕业，具有扎实的汽车理论知识，拥有实际操作和故障分析能力，良好的文字表达能力。',
      },
      {
        title: '汽车电器工程师',
        desc: '电子或电器专业毕业，有良好的电器基础。多年汽车电器诊断经验。',
      },
      {
        title: '机械工程师',
        desc: '有多年的工具设计、加工经验，对材料、加工工艺、热处理等有非常专业的研究。',
      },
      {
        title: '资深平面设计师',
        desc: '拥有长期从事汽车图文设计与制作的团队，致力于汽车技术与美术的完美结合。平面设计各项分工明确，成功参与过东风集团公司、东风乘用车、东风本田、东风雪铁龙、东风标致、东风工程车、东风股份等各公司的技术文档、以及平面宣传品等设计制作工作。',
      },
      {
        title: '三维动画设计师',
        desc: '熟练使用三维制作软件，有较强的三维制作能力，艺术设计能力，为团队提供在AR业务端的设计制作支持了解掌握特效制作软件，掌握模型制作、材质、渲染等制作流程。熟练掌握动画运动规律，较强的动画节奏把控能力，有良好的画面节奏感、创意及想象力。',
      },
      {
        title: '程序员',
        desc: '拥有丰富前端开发经验的开发者，精通HTML和CSS技术，并熟练掌握Vue框架和Web3D技术。善于使用HTML和CSS创建清晰、易于维护的代码，并且能够灵活运用Vue框架实现动态交互和响应式设计。具备Web3D技术的知识和技能，能够将3D场景和动画融入到Web开发中提高用户体验和页面视觉效果。',
      },
      {
        title: '文字编辑',
        desc: '新闻或汉语言文学专业，良好的文字功底与语言表达能力，对汽车知识有一定的了解，审核技术文档的文字表达。',
      },
      {
        title: '视频编辑',
        desc: '具有视频的拍摄、剪辑与后期制作的能力。',
      },
      {
        title: '质量督导',
        desc: '具有丰富的汽车技术文档开发经验，对技术文档和专用工具进行总体质量把控。',
      },
    ],
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // Address.vue - 联系我们
  address: {
    companyName: '武汉福卡迪汽车技术有限公司',
    contact: '陈峰',
    mobile: '138 0712 1650',
    landline: '152 0270 8329',
    email: 'mail@forcartech.com',
    bizAddress: '武汉市经济技术开发区东风大道枫树五路上元云谷30栋',
    qrcode: '扫码关注福卡迪公众号',
    seoTitle: '汽车维修手册与培训系统开发 | 福卡迪汽车技术',
    seoDescription: '提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。',
    seoKeywords: '汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译',
  },

  // Ability3.vue - 信用中国/专业荣誉
  ability3: {
    tab1: '信用中国',
    tab1Title: '陈峰：汽车售后技术的一站式服务',
    tab1Original: '原创',
    tab1Column: '信用中国电视栏目',
    tab1Date: '信用中国 | 2024/03/04',
    tab1Desc: '随着汽车产业的日新月异，消费者对汽车质量、性能和服务的要求不断提升。在这一大背景下，汽车制造商和销售商必须提供专业的汽车技术服务和创新的营销手段，以在激烈的市场竞争中站稳脚跟。而在这股变革的浪潮中，陈峰先生以其深厚的行业经验和前瞻的视野，带领武汉福卡迪汽车技术有限公司走在了行业的前列。',
    tab1Link: '查看详情 →',
    tab2: '专业荣誉',
    tab2Title: '荣誉荣膺：第二届汽车维修信息公开专家委员会专家（委员）',
    tab2Desc: '在行业内深耕多年的专业积累与卓越贡献下，陈峰同志荣膺"第二届汽车维修信息公开专家委员会专家（委员）"荣誉，并正式获聘为期三年的委员会成员。此项荣誉不仅体现了其在汽车维修领域的专业地位，也标志着在促进汽车维修信息公开与标准化工作中的重要作用。凭借深厚的行业背景和技术优势，他将在未来三年中继续为推动行业发展、提升维修服务水平作出重要贡献。',
  },

  // router meta titles
  route: {
    about: '关于我们',
    address: '联系我们',
    case: '项目案例',
    culture: '企业文化',
    team: '团队介绍',
    bd: '百度百科',
  },
}
